
// Companies for reuse
export const companies = {
  techCorp: 'TechCorp',
  mediHealth: 'MediHealth',
  investGroup: 'InvestGroup',
  retailPlus: 'RetailPlus',
  ecoSolutions: 'EcoSolutions'
};

// Contacts for reuse
export const contacts = {
  techCorp: 'Alex Johnson',
  mediHealth: 'Sam Taylor',
  investGroup: 'Jordan Rivera',
  retailPlus: 'Morgan Chen',
  ecoSolutions: 'Jamie Wilson'
};

// Team members for reuse
export const teams = {
  development: ['Jane Doe', 'John Smith', 'Alice Brown'],
  design: ['Bob White', 'Sarah Green', 'Mike Blue', 'Lisa Gray'],
  planning: ['Chris Purple', 'Emma Yellow'],
  testing: ['David Orange', 'Olivia Red', 'Tom Black'],
  marketing: ['Rachel Pink', 'Nathan Brown'],
  cloud: ['Mark Gold', 'Sophia Silver'],
  content: ['Ryan Teal', 'Natalie Cyan'],
  payment: ['Victor Violet', 'Penelope Plum'],
  security: ['Howard Hazel', 'Irene Ivory'],
  devops: ['Quentin Quartz', 'Ursula Umber'],
  training: ['Xavier Xanthic', 'Yvonne Yellow'],
  support: ['Zach Zinc', 'Wendy White'],
  social: ['Adam Azure', 'Betty Beige'],
  data: ['Charlie Crimson', 'Donna Diamond'],
  mobileApp: ['Edward Emerald', 'Fiona Fuchsia'],
};
